<h1 mat-dialog-title [innerHTML]="'D3' | translate : data.locale : placeholders"></h1>
<div mat-dialog-content>
  <div class="loader-container loader-container-s" *ngIf="loading">
    <div class="loader loader-s"></div>
  </div>
  <div *ngIf="!loading && accounts.length">
    <ul>
      <li *ngFor="let account of accounts">
        {{ account }}
      </li>
    </ul>
  </div>
  <div [innerHTML]="'D40' | translate : data.locale : placeholders" *ngIf="!loading && !accounts.length">
  </div>
</div>